import { MapTheme } from '@cibo/mapgl'
import { useTheme } from '@mui/material'
import { useMemo } from 'react'

export const useBoundaryStyles = () => {
  const theme = useTheme<MapTheme>()

  const boundaryStyles = useMemo(
    () => ({
      fill: {
        'fill-color': theme.palette.selectFill,
        'fill-opacity': 0.3,
      },
      paint: {
        'line-color': theme.palette.selectLine,
        'line-opacity': 0.5,
        'line-width': ['interpolate', ['linear'], ['zoom'], 10, 4, 12, 7],
      },
    }),
    [theme]
  )

  return boundaryStyles
}
